import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/tailwind.css'
import './styles/theme-tokens.css'
import './styles/uniform-dashboard.css'

// Asegura consistencia de tema en recargas directas de cualquier ruta.
try {
  const storedTheme = localStorage.getItem('theme')
  const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  const useDark = storedTheme ? storedTheme === 'dark' : prefersDark
  document.documentElement.classList.toggle('dark', useDark)
} catch (_) {}

// Captura global de errores para registrar en consola y/o backend
window.onerror = function(message, source, lineno, colno, error) {
  try {
    console.error('[GlobalError]', { message, source, lineno, colno, error });
  } catch (_) {}
};
window.onunhandledrejection = function(event) {
  try {
    console.error('[UnhandledRejection]', event.reason || event);
  } catch (_) {}
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
